import { createFileRoute, useSearch } from '@tanstack/react-router';
import { ContainerTypeLegacy, DevicesLayout, navigateToError } from '@amber-ui/core';

function PileDevicesRoute() {
  const { pile } = useSearch({ strict: false }) as { pile?: string };
  const pile_id = pile || null;

  if (!pile_id) return null;

  return (
    <DevicesLayout
      container_id={pile_id}
      container_type={ContainerTypeLegacy.pile}
      onError={() => {
        navigateToError();
      }}
      onHubAssignmentSuccess={() => {}}
      onAssignFanControllerSuccess={() => {}}
      onUnassignFanControllerSuccess={() => {}}
    />
  );
}

export const Route = createFileRoute('/_auth/_pile/pile/devices')({
  component: PileDevicesRoute,
});
